export default __webpack_public_path__ + "static/media/96eeff046776c431b2967a1cfe65b98a.md";